import Image from 'next/image';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { Button } from 'antd';

interface IData {
  btnText: string;
  cards: {
    desc: string;
    imgPath: string;
    svg: string;
    title: string;
  }[];
  desc: string;
  title: string;
  imgPath: string;
}

export default function WhyChoose({ data }: { data: IData }) {
  const [current, setCurrent] = useState<number>(0);
  const [svgList, setSvgList] = useState<string[]>([]);

  useEffect(() => {
    async function fetchSvgs() {
      if (data.cards?.length) {
        const newSvgList = [];
        for (const card of data.cards) {
          try {
            const res = await fetch(`/n-api/image-proxy?url=${encodeURIComponent(card.svg)}`).then((res) => res.text());
            newSvgList.push(res);
          } catch (e) {
            newSvgList.push(null);
          }
        }
        setSvgList(newSvgList);
      }
    }
    fetchSvgs();
  }, [data.cards]);

  return (
    <div className="max-w-5xl mx-auto px-4 pt-16">
      <h2 className="max-w-3xl px-4 mx-auto font-bold text-4xl text-center max-md:text-[28px]">{data.title}</h2>
      <div className="max-w-3xl mx-auto text-center mt-9 max-md:mt-4 primary-text-60">{data.desc}</div>
      <div className="flex items-center rounded-2xl pt-14 max-md:pt-10 max-md:flex-col ">
        <div className="flex-1 pr-[75px] border-r border-r-[#D9D9D9] max-md:pr-0 max-md:border-none">
          <Image src={data.cards[current].imgPath} width={516} height={458} alt={data.cards[current].title} />
        </div>
        <div className="flex-1 flex flex-col gap-14 max-md:gap-6 max-md:border-l max-md:border-l-[#D9D9D9] max-md:mt-12">
          {data.cards.map((card, i) => (
            <div
              key={i}
              className={cn('pl-[75px] max-md:pl-4 border-l border-l-transparent relative -left-[1px]', {
                'border-l-[#725CFF]': i === current,
              })}
            >
              <h3
                className={cn('flex items-center text-lg cursor-pointer', { 'text-[#725CFF]': i === current })}
                onClick={() => setCurrent(i)}
              >
                <span className="w-7 h-7 flex-center mr-4" dangerouslySetInnerHTML={{ __html: svgList[i] }} />
                {card.title}
              </h3>
              <div
                className={cn('transition-[max-height] max-h-[0] overflow-hidden', {
                  'max-h-[200px]': i === current,
                })}
              >
                <div className="primary-text-60">{card.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex-center pt-14">
        <Button
          className="h-[38px] border-none bg-gradient-to-b px-10 from-[#725CFF] to-[#8D83FFCC] font-bold text-sm"
          type="primary"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          {data.btnText}
        </Button>
      </div>
    </div>
  );
}
